<template>
    <div class="recommend-products">
        <div class="tem-title">推荐产品</div>
        <div v-if="isCollapse">
            <van-collapse
                v-if="Object.keys(product) && Object.keys(product).length"
                v-model="activeNames"
                :border="false"
                class="product-list"
            >
                <van-collapse-item
                    v-for="item in Object.keys(product)"
                    :key="item"
                    :title="item"
                    :name="item"
                    :border="false"
                >
                    <template #right-icon>
                        <img
                            class="list-icon"
                            :src="
                                activeNames.includes(item)
                                    ? 'https://oss.cloud.custouch.com/res/217139/icon-close@3x.png'
                                    : 'https://oss.cloud.custouch.com/res/217140/icon-open@3x.png'
                            "
                            alt=""
                        />
                    </template>
                    <div class="product">
                        <productItem
                            v-for="item in product[item]"
                            :key="item.id"
                            :item="item"
                        ></productItem>
                    </div>
                </van-collapse-item>
            </van-collapse>
        </div>
        <div v-else class="product">
            <productItem
                v-for="item in list"
                :key="item.id"
                :item="item"
            ></productItem>
        </div>
    </div>
</template>
<script>
import productItem from './Item.vue'
export default {
    props: ['isGroup', 'list'],
    components: { productItem },
    data() {
        return {
            isCollapse: false,
            product: {},
            activeNames: []
        }
    },
    created() {
        if (this.isGroup !== 'n') {
            this.isCollapse = this.list.every(item => item.detail.type)
            if (this.isCollapse) {
                let typeList = [
                    ...new Set(this.list.map(item => item.detail.type))
                ]
                this.product = typeList.reduce((pre, cur) => {
                    pre[cur] = this.list.filter(
                        item => item.detail.type === cur
                    )
                    return pre
                }, {})
            }
        }
    }
}
</script>
<style lang="less" scoped>
.recommend-products {
    .tem-title {
        color: @green;
        font-weight: @font-weight-bold;
        font-size: @font-size-lg;
        line-height: @line-height-md;
        display: flex;
        align-items: center;
        margin-bottom: @padding-md;
        &::before {
            content: '';
            display: inline-block;
            width: 0.2rem;
            height: 0.8rem;
            background: #00a6eb;
            margin-right: 0.5rem;
        }
    }
    .product {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        grid-template-rows: auto;
        gap: @padding-md;
    }
}
</style>
<style lang="less">
.recommend-products {
    .list-icon {
        height: @font-size-md;
    }
    .van-collapse-item {
        margin-bottom: @padding-md;
        .van-collapse-item__title {
            align-items: center;
            box-shadow: 0 0.05rem 0.2rem 0 #004da029;
            background: @white;
            border-radius: @border-radius-sm + @border-radius-md;
            color: @green;
            font-size: @font-size-lg;
            line-height: @line-height-md;
        }
        .van-collapse-item__content {
            padding: @padding-md 0 @padding-xs;
            background: transparent;
        }
    }
}
</style>
